/* TEST A/B E MISURA DEL SITO, la meta' che gira DOPO il caricamento (27/09/2026, docs/SITO-AB-TEST.md).
   La versione l'ha gia' scelta snippets/cp-ab-head.liquid, in cima a <head>. Qui si fa il resto:
   1. si CONTA chi ha visto la misura o un test (beacon al server della dashboard: /ab/e);
   2. si scrive la versione nel CARRELLO (ab_vid, ab_<test>), cosi' arriva sull'ordine;
   3. si mette un'etichetta in CLARITY (ab_<test> = A o B) per rivedere le registrazioni per versione;
   4. sulla PDP: fin dove si scorre e per quanto si resta, e i clic su galleria, FAQ, recensioni, slider...
   Il builder chiama window.CP_AB.ev('bo'|'c1'|'s3'|'co') e CP_AB.attrs() subito prima del checkout.
   ⛔ Questo file non tocca MAI righe o quantita' del carrello, solo gli attributi (il carrello doppio
   di agosto nasceva da add.js: memoria scratchlight_cart_doubling). */
(function () {
  'use strict';
  var W = window, D = document, A = W.CP_AB;
  if (!A || A._ready) return;
  A._ready = true;
  var C = A.cfg || {}, S = W.Shopify || {};
  var ua = navigator.userAgent || '';

  function ck(n) { var m = D.cookie.match(new RegExp('(?:^|; )' + n + '=([^;]*)')); return m ? decodeURIComponent(m[1]) : ''; }
  function sc(n, v, age) { D.cookie = n + '=' + encodeURIComponent(v) + '; path=/; SameSite=Lax; max-age=' + age + (location.protocol === 'https:' ? '; Secure' : ''); }
  function keys(o) { return Object.keys(o || {}); }

  /* Chi non entra nei dati: editor, anteprima (?cp_ab=), traffico nostro, bot. I bot che non eseguono
     JavaScript non arrivano nemmeno qui; questi sono quelli che lo eseguono. */
  var bot = navigator.webdriver || /bot|crawl|spider|slurp|facebookexternalhit|facebot|adsbot|mediapartners|headless|lighthouse|pagespeed|prerender|gtmetrix|pingdom/i.test(ua);
  var off = !!(C.editor || A.qa || A.internal || bot || !C.endpoint);
  /* Il tema pubblicato conta come "live"; il tema di sviluppo e le anteprime come "dev" (il server li tiene separati). */
  var env = (S.theme && S.theme.role === 'main') ? 'live' : 'dev';
  var src = /Instagram/i.test(ua) ? 'ig' : /FBAN|FBAV|FB_IAB|FBIOS|FB4A/i.test(ua) ? 'fb' : 'web';
  var dv = /Mobi|Android|iPhone|iPad|iPod/i.test(ua) ? 'm' : 'd';
  var pg = C.kit ? 'pdp' : (String(C.page || 'other').replace(/[^a-z_]/g, '').slice(0, 16) || 'other');

  /* Il consenso di Shopify: dove serve (UE) si rispetta; negli USA l'API dice gia' si'. */
  function consent() {
    try {
      var cp = S.customerPrivacy;
      if (cp && typeof cp.analyticsProcessingAllowed === 'function') return !!cp.analyticsProcessingAllowed();
    } catch (e) {}
    return true;
  }

  /* I test (e la misura) che contano su QUESTA pagina */
  function applies(t) {
    if (t.pagine === 'pdp' && !C.kit) return false;
    if (C.view && !t.viste) return false;
    return true;
  }
  var here = {};
  (C.tests || []).forEach(function (t) { if (A.live[t.id] && applies(t)) here[t.id] = A.live[t.id]; });

  /* Quelli che il visitatore ha GIA' visto (anche su un'altra pagina): cookie, oppure il carrello. */
  var expo = {};
  String(ck('cp_ab_x')).split(',').forEach(function (id) { if (A.live[id]) expo[id] = A.live[id]; });
  (C.tests || []).forEach(function (t) { if (A.live[t.id] && (t.cart === 'A' || t.cart === 'B')) expo[t.id] = A.live[t.id]; });
  for (var id in here) expo[id] = here[id];
  if (keys(here).length && !off) sc('cp_ab_x', keys(expo).join(','), 7776000);

  function send(e, tests, extra) {
    if (off || !consent() || !keys(tests).length) return;
    var o = { v: 1, e: e, vid: A.vid, env: env, t: tests, pg: pg, vw: C.view || '', src: src, dv: dv };
    for (var k in (extra || {})) o[k] = extra[k];
    var body = JSON.stringify(o);
    try {
      if (navigator.sendBeacon && navigator.sendBeacon(C.endpoint, new Blob([body], { type: 'text/plain' }))) return;
    } catch (x) {}
    try { fetch(C.endpoint, { method: 'POST', body: body, keepalive: true, mode: 'no-cors', headers: { 'Content-Type': 'text/plain' } }); } catch (x) {}
  }

  /* Gli attributi del carrello: ab_vid + ab_<test> di cio' che e' stato visto. Vuoto per chi non entra nei dati. */
  A.attrs = function () {
    if (off || !consent() || !keys(expo).length) return {};
    var o = { ab_vid: A.vid };
    for (var id in expo) o['ab_' + id] = expo[id];
    return o;
  };
  function attrsMancanti() {
    var at = A.attrs();
    if (!at.ab_vid) return null;
    var need = C.vid !== A.vid;
    (C.tests || []).forEach(function (t) { if (at['ab_' + t.id] && at['ab_' + t.id] !== t.cart) need = true; });
    return need ? at : null;
  }
  var scritti = false;
  function scriviCarrello() {
    var at = attrsMancanti();
    if (!at || scritti) return;
    scritti = true;
    fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: at }) }).catch(function () { scritti = false; });
  }
  /* Il checkout dal carrello (cassetto o pagina): gli attributi viaggiano come campi nascosti del form,
     cosi' anche chi non passa dal builder porta la versione sull'ordine. */
  D.addEventListener('submit', function (e) {
    try {
      var f = e.target, at = A.attrs();
      if (!f || !f.getAttribute || !/\/cart\b/.test(f.getAttribute('action') || '') || !at.ab_vid) return;
      for (var k in at) {
        var nm = 'attributes[' + k + ']', el = f.querySelector('input[name="' + nm + '"]');
        if (!el) { el = D.createElement('input'); el.type = 'hidden'; el.name = nm; f.appendChild(el); }
        el.value = at[k];
      }
    } catch (x) {}
  }, true);

  /* Gli eventi del builder: apertura, prima citta', riepilogo, checkout. Uno per pagina e per tipo. */
  var done = {};
  A.ev = function (e) {
    try {
      if (!/^(bo|c1|s3|co)$/.test(e) || done[e]) return;
      done[e] = 1;
      send(e, expo);
    } catch (x) {}
  };

  /* ── La PDP: fin dove si scorre (quota della pagina vista) e per quanto si resta davanti ── */
  var sd = 0, tmTot = 0, tmSent = 0, visDa = 0;
  function misuraScroll() {
    var h = D.documentElement.scrollHeight || D.body.scrollHeight || 1;
    var y = W.scrollY || W.pageYOffset || 0;
    var d = Math.min(100, Math.round((y + W.innerHeight) / h * 100));
    if (d > sd) sd = d;
  }
  function mandaScroll() {
    if (!C.kit) return;
    if (visDa) { tmTot += (Date.now() - visDa) / 1000; visDa = 0; }
    var s = Math.round(tmTot - tmSent);
    if (s < 1 && !sd) return;
    tmSent += Math.max(0, s);
    send('sc', here, { d: sd, s: Math.max(0, Math.min(3600, s)) });
  }
  if (C.kit) {
    W.addEventListener('scroll', misuraScroll, { passive: true });
    D.addEventListener('visibilitychange', function () {
      if (D.visibilityState === 'hidden') mandaScroll();
      else visDa = Date.now();
    });
    W.addEventListener('pagehide', mandaScroll);
  }

  /* ── I clic che dicono cosa guarda la gente (uno per pagina e per tipo) ── */
  var fatti = {};
  function azione(k) {
    if (fatti[k]) return;
    fatti[k] = 1;
    send('ck', here, { k: k });
  }
  /* 27/09: anche il builder segna le sue azioni ("lc" = Let us choose aperto, "lcg" = set scelto e messo nel builder).
     Una volta per pagina come le altre. Il server le accetta solo dopo il deploy della dashboard con lc/lcg in AZIONI. */
  A.azione = function (k) { try { if (C.kit) azione(k); } catch (x) {} };
  /* 30/09: il popup "Try your luck" (snippets/cp-luck-popup.liquid) segna i suoi passi su OGNI pagina, non solo sulla PDP:
     lv visto, lf prima carta, l3 tre carte, lw per chi e', ls email inviata, lx chiuso senza iscriversi. Il server le accetta
     solo dopo il deploy della dashboard con queste sigle in AZIONI. */
  A.luck = function (k) { try { if (/^l[vf3wsx]$/.test(k)) azione(k); } catch (x) {} };
  if (C.kit) {
    D.addEventListener('pointerup', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      if (t.closest('media-gallery, slideshow-component')) azione('gal');
    }, true);
    D.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      if (t.closest('a[href="#reviews"], .jdgm-widget, #judgeme_product_reviews')) azione('rev');
      else if (t.closest('a[href="#reveal"]')) azione('rvl');
      else if (t.closest('.cp-bb__ugc-wrap')) azione('ugc');
      else if (t.closest('[id*="cp_pdp_nav"] a')) azione('nav');
    }, true);
    D.addEventListener('toggle', function (e) {
      var d = e.target;
      if (!d || !d.open || !d.closest) return;
      if (d.closest('.cp-ppfaq__list')) azione('faq');
      else if (d.closest('.cp-bb__acc')) azione('acc');
    }, true);
    D.addEventListener('input', function (e) {
      if (e.target && e.target.matches && e.target.matches('[data-cp-pprev-range]')) azione('rvl');
    }, true);
  }

  function pageview() {
    send('pv', here);
    /* Il carrello si scrive solo se ha gia' qualcosa dentro (per chi entra dal builder lo fa il builder,
       nella chiamata che esisteva gia'): niente carrelli creati per chi guarda e basta. */
    if (C.items > 0) scriviCarrello();
    /* Clarity: le registrazioni e le heatmap si filtrano per versione (etichetta ab_<test>). */
    if (!off && consent() && keys(expo).length) {
      W.clarity = W.clarity || function () { (W.clarity.q = W.clarity.q || []).push(arguments); };
      for (var id in expo) { try { W.clarity('set', 'ab_' + id, expo[id]); } catch (x) {} }
    }
    if (C.kit) { visDa = Date.now(); misuraScroll(); }
  }

  /* La pagina conta solo quando e' davvero davanti a qualcuno (niente precaricamenti in background). */
  function whenVisible(fn) {
    if (D.visibilityState === 'visible') return fn();
    var h = function () { if (D.visibilityState === 'visible') { D.removeEventListener('visibilitychange', h); fn(); } };
    D.addEventListener('visibilitychange', h);
  }
  A._pageview = pageview;   /* solo per il QA dalla console (es. dopo aver dato il consenso) */
  function start() { whenVisible(pageview); }
  if (D.readyState === 'complete') start(); else W.addEventListener('load', start);

  /* Gli eventi arrivati prima di questo file */
  var q = A.q || []; A.q = [];
  q.forEach(function (e) { A.ev(e); });
})();
